// // import { Col, Row, Select, Table, Spin, message } from "antd";
// // import React, { useEffect, useState } from "react";
// // import dataService from "../networks/api/service/dataService";
// // import { useLocation } from "react-router-dom";

// // const { Option } = Select;

// // function AssemblyBriefDetails() {
// //   const location = useLocation();

// //   const [data, setData] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [tableData, setTableData] = useState([]);

// //   const { selectedAssembly, year, electionType } = location.state || {};
// //   console.log(
// //     selectedAssembly,
// //     year,
// //     electionType,
// //     "selectedAssembly, year, electionType"
// //   );
// //   // Flatten the nested response structure
// //   const flattenResponse = (response) => {
// //     if (response.data) {
// //       const { electionDetails, position, votePercentage } = response.data;

// //       // Combine the nested objects into one flat object
// //       return {
// //         ...electionDetails,
// //         ...position,
// //         ...votePercentage,
// //       };
// //     }
// //     return {};
// //   };

// //   // Transform the data for Y-axis headers and X-axis values
// //   const transformToTransposedData = (data, year) => {
// //     const transposedData = Object.entries(data).map(([key, value]) => ({
// //       header: key
// //         .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase to words
// //         .replace(/_/g, " ") // Replace underscores with spaces
// //         .toUpperCase(),
// //       value: value !== null ? value : "-", // Handle null values gracefully
// //     }));

// //     return transposedData;
// //   };

// //   // Fetch data and process it
// //   const fetchAssemblyData = async () => {
// //     // if (!selectedAssembly || !year || !electionType) return;

// //     setLoading(true);
// //     try {
// //       let response;
// //       if (electionType === "AC") {
// //         response = await dataService.getAssemblyElectionAc(
// //           selectedAssembly,
// //           year
// //         );
// //       } else if (electionType === "PC") {
// //         response = await dataService.getAssemblyElectionPc(
// //           selectedAssembly,
// //           year
// //         );
// //       }

// //       if (response && response.data) {
// //         const flattenedData = flattenResponse(response);
// //         const transposedData = transformToTransposedData(flattenedData, year);
// //         setTableData(transposedData);
// //       } else {
// //         message.error("No data available for the selected criteria.");
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       message.error("Error fetching data.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (selectedAssembly && year && electionType) {
// //       fetchAssemblyData();
// //     }
// //   }, [selectedAssembly, year, electionType]);

// //   // Table columns for transposed data
// //   const transposedColumns = [
// //     {
// //       title: "HEADER",
// //       dataIndex: "header",
// //       key: "header",
// //       width: "50%",
// //     },
// //     {
// //       title: year || "VALUE", // Display selected year as column title
// //       dataIndex: "value",
// //       key: "value",
// //       width: "50%",
// //     },
// //   ];

// //   return (
// //     <div style={{ padding: "20px" }}>
// //       {loading ? (
// //         <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
// //       ) : (
// //         <Table
// //           columns={transposedColumns}
// //           dataSource={tableData}
// //           rowKey={(record, index) => index}
// //           pagination={false}
// //           style={{ marginTop: "20px" }}
// //         />
// //       )}
// //     </div>
// //   );
// // }

// // export default AssemblyBriefDetails;

// import { Col, Row, Select, Table, Spin, message, Typography } from "antd";
// import React, { useEffect, useState } from "react";
// import dataService from "../networks/api/service/dataService";
// import { useLocation, useNavigate } from "react-router-dom";
// import colors from "../assets/styles/colour";

// const { Option } = Select;

// function AssemblyBriefDetails() {
//   const location = useLocation();

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [tableData, setTableData] = useState([]);
//   const [electionDetails, setElectionDetails] = useState([]);
//   const navigate = useNavigate();

//   const { selectedAssembly, year, electionType, assemblyName } =
//     location.state || {};

//   // Flatten the nested response structure
//   const flattenResponse = (response) => {
//     if (response.data) {
//       const { electionDetails, position, votePercentage } = response.data;
//       return {
//         ...electionDetails,
//         ...position,
//         ...votePercentage,
//       };
//     }
//     return {};
//   };

//   // Transform the data for Y-axis headers and X-axis values
//   const transformToTransposedData = (data, year) => {
//     const transposedData = Object.entries(data).map(([key, value]) => ({
//       header: key, // Keep the exact key for conditional API calls
//       displayHeader: key
//         .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase to words
//         .replace(/_/g, " ") // Replace underscores with spaces
//         .toUpperCase(),
//       value: value !== null ? value : "-", // Handle null values gracefully
//     }));

//     return transposedData;
//   };

//   // Fetch data and process it
//   const fetchAssemblyData = async () => {
//     setLoading(true);
//     try {
//       let response;
//       if (electionType === "AC") {
//         response = await dataService.getAssemblyElectionAc(
//           selectedAssembly,
//           year
//         );
//       } else if (electionType === "PC") {
//         response = await dataService.getAssemblyElectionPc(
//           selectedAssembly,
//           year
//         );
//       }

//       if (response && response.data) {
//         const flattenedData = flattenResponse(response);
//         const transposedData = transformToTransposedData(flattenedData, year);
//         setTableData(transposedData);
//       } else {
//         message.error("No data available for the selected criteria.");
//       }
//     } catch (error) {
//       console.error(error);
//       message.error("Error fetching data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle row click to fetch analysis data
//   const handleRowClick = async (record) => {
//     const { header } = record; // Use the exact header key for the API
//     console.log(header);
//     // Only proceed if the header matches specific criteria
//     if (
//       ["above45", "thirtyTo45", "below30", "first", "second", "third"].includes(
//         header
//       )
//     ) {
//       const position = ["first", "second", "third"].includes(header)
//         ? header
//         : null;
//       const votePercentage = ["above45", "thirtyTo45", "below30"].includes(
//         header
//       )
//         ? header
//         : null;

//       setLoading(true);
//       try {
//         let response;
//         if (electionType === "AC") {
//           response = await dataService.getAssemblyAnalysisAc(
//             selectedAssembly,
//             year,
//             votePercentage,
//             position
//           );
//         } else if (electionType === "PC") {
//           response = await dataService.getAssemblyAnalysisPc(
//             selectedAssembly,
//             year,
//             votePercentage,
//             position
//           );
//         }

//         if (response && response.data) {
//           // setElectionDetails(response.data);
//           navigate("/login/all-level-election-page", {
//             state: { electionDetails: response.data },
//           });
//         } else {
//           message.error("No data available for the selected criteria.");
//         }
//       } catch (error) {
//         console.error(error);
//         message.error("Error fetching data.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   // const electionDetailsColumns = [
//   //   { title: "SL NO", dataIndex: "SL NO", key: "SL NO" },
//   //   { title: "BOOTH NAME", dataIndex: "BOOTH NAME", key: "BOOTH NAME" },
//   //   { title: "BJP MD", dataIndex: "BJP MD", key: "BJP MD" },
//   //   { title: "BJD LN", dataIndex: "BJD LN", key: "BJD LN" },
//   //   { title: "INC DM", dataIndex: "INC DM", key: "INC DM" },
//   //   { title: "Total", dataIndex: "Total", key: "Total" },
//   //   { title: "Rank", dataIndex: "Rank", key: "Rank" },
//   //   { title: "%", dataIndex: "%", key: "%" },
//   //   { title: "YEAR", dataIndex: "YEAR", key: "YEAR" },
//   // ];

//   useEffect(() => {
//     if (selectedAssembly && year && electionType) {
//       fetchAssemblyData();
//     }
//   }, [selectedAssembly, year, electionType]);

//   // Table columns for transposed data
//   const transposedColumns = [
//     {
//       title: "HEADER",
//       dataIndex: "displayHeader", // Display transformed header text
//       key: "displayHeader",
//       width: "50%",
//     },
//     {
//       title: year || "VALUE", // Display selected year as column title
//       dataIndex: "value",
//       key: "value",
//       width: "50%",
//     },
//   ];

//   return (
//     <div style={{ padding: "20px" }}>
//       <Typography
//         color={colors.textSecondary}
//         variant="h3"
//         fontWeight="bold"
//         style={{ fontSize: "20px", marginBottom: 10 }}
//       >
//         Assembly Name : {assemblyName}
//       </Typography>
//       {loading ? (
//         <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
//       ) : (
//         <Table
//           columns={transposedColumns}
//           dataSource={tableData}
//           rowKey={(record, index) => index}
//           pagination={false}
//           style={{
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "8px",
//             backgroundColor: "#fff",
//             width: "100%",
//             overflowX: "auto",
//           }}
//           scroll={{ x: 800 }}
//           onRow={(record) => ({
//             onClick: () => handleRowClick(record), // Handle row clicks
//           })}
//         />
//       )}
//       <br />
//       <br />

//       {/* {electionDetails.length > 0 && (
//         <Table
//           columns={electionDetailsColumns}
//           dataSource={electionDetails}
//           rowKey={(record) => record.key}
//           pagination={{ pageSize: 10 }}
//           style={{
//             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//             borderRadius: "8px",
//             backgroundColor: "#fff",
//             width: "100%",
//             overflowX: "auto",
//           }}
//           scroll={{ x: 800 }}
//         />
//       )} */}
//     </div>
//   );
// }

// export default AssemblyBriefDetails;

import { Table, Spin, message, Typography, Button } from "antd";
import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../assets/styles/colour";
import { LeftOutlined } from "@ant-design/icons";

function AssemblyBriefDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  const { selectedAssembly, year, electionType, assemblyName } =
    location.state || {};
  console.log(assemblyName, "assemblyName");
  // Transform data for side-by-side comparison
  const transformDataForComparison = (data) => {
    const headers = {};

    // Aggregate data by header
    data.forEach((entry) => {
      const { year, electionDetails, position, votePercentage } = entry;

      // Combine all keys into a single object
      const allData = {
        ...electionDetails,
        ...position,
        ...votePercentage,
      };

      // Iterate over all keys
      for (const [key, value] of Object.entries(allData)) {
        if (!headers[key]) {
          headers[key] = { header: key };
        }
        headers[key][year] = value !== null ? value : "-";
      }
    });

    // Convert to array for Ant Design Table
    return Object.values(headers);
  };

  // Handle row click to fetch analysis data
  const handleAssemblyAnalysis = async (record, clickedYear, value) => {
    const { header } = record; // Use the exact header key for the API
    // console.log(header, record, "record");
    // Only proceed if the header matches specific criteria
    if (
      ["above45", "thirtyTo45", "below30", "first", "second", "third"].includes(
        header
      )
    ) {
      const position = ["first", "second", "third"].includes(header)
        ? header
        : null;
      const votePercentage = ["above45", "thirtyTo45", "below30"].includes(
        header
      )
        ? header
        : null;

      setLoading(true);
      try {
        let response;
        if (electionType === "AC") {
          response = await dataService.getAssemblyAnalysisAc(
            selectedAssembly,
            clickedYear,
            votePercentage,
            position
          );
        } else if (electionType === "PC") {
          response = await dataService.getAssemblyAnalysisPc(
            selectedAssembly,
            clickedYear,
            votePercentage,
            position
          );
        }

        if (response && response.data) {
          // setElectionDetails(response.data);
          navigate("/login/all-level-election-page", {
            state: { electionDetails: response.data },
          });
        } else {
          message.error("No data available for the selected criteria.");
        }
      } catch (error) {
        console.error(error);
        message.error("Error fetching data.");
      } finally {
        setLoading(false);
      }
    }
  };

  // Fetch data
  const fetchAssemblyData = async () => {
    setLoading(true);
    try {
      let response;
      if (electionType === "AC") {
        response = await dataService.getAssemblyElectionAc(
          selectedAssembly,
          year
        );
      } else if (electionType === "PC") {
        response = await dataService.getAssemblyElectionPc(
          selectedAssembly,
          year
        );
      }

      if (response && response.data) {
        const transformedData = transformDataForComparison(response.data);

        // Create columns dynamically
        const years = response.data.map((item) => item.year);
        const dynamicColumns = [
          {
            title: "Header",
            dataIndex: "header",
            key: "header",
            onCell: (record) => ({
              onClick: () => {
                console.log("Header clicked:", record.header);
                // message.info(`Clicked Header: ${record.header}`);
              },
            }),
            render: (text) =>
              text
                .replace(/([a-z])([A-Z])/g, "$1 $2") // Split camelCase
                .replace(/_/g, " ") // Replace underscores
                .toUpperCase(), // Convert to uppercase
            width: "30%",
          },
          ...years.map((yr) => ({
            title: yr,
            dataIndex: yr,
            key: yr,
            width: `${70 / years.length}%`,

            onCell: (rowRecord) => ({
              onClick: () => handleCellClick(rowRecord, yr, rowRecord[yr]),
            }),
          })),
        ];

        setTableData(transformedData);
        setColumns(dynamicColumns);
      } else {
        message.error("No data available for the selected criteria.");
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const handleCellClick = (record, clickedYear, value) => {
    console.log("Row record:", record); // e.g., "above45"
    console.log("Column Year:", clickedYear); // e.g., "2023"
    console.log("Cell Value:", value); // e.g., "50%"
    handleAssemblyAnalysis(record, clickedYear, value);
    // Perform logic or API call
    // message.info(
    //   `Row: ${record.header}, Column: ${clickedYear}, Value: ${value}`
    // );
  };

  useEffect(() => {
    if (selectedAssembly && year && electionType) {
      fetchAssemblyData();
    }
  }, [selectedAssembly, year, electionType]);

  return (
    <div style={{ padding: "20px" }}>
      <Typography
        color={colors.textSecondary}
        variant="h3"
        fontWeight="bold"
        style={{ fontSize: "20px", marginBottom: 10 }}
      >
        {assemblyName}
      </Typography>
      <Button
        type="primary"
        icon={<LeftOutlined />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: "20px", background: colors.primary }}
      >
        Go Back
      </Button>
      {loading ? (
        <Spin size="large" style={{ display: "block", marginTop: "20px" }} />
      ) : (
        <Table
          columns={columns}
          dataSource={tableData}
          rowKey={(record) => record.header}
          pagination={false}
          style={{
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            backgroundColor: "#fff",
            width: "100%",
            overflowX: "auto",
          }}
          scroll={{ x: 800 }}

          // onRow={(record) => ({
          //   onClick: () => handleRowClick(record), // Handle row clicks
          // })}
        />
      )}
    </div>
  );
}

export default AssemblyBriefDetails;
